import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CustomLink } from "../../custom-link";
import get from "lodash/get";

import "./request-subscription.m.css";
import { SvgHandler } from "../../svg-handler/svg-handler";
import closeIcon from "../../../../assets/icons/social/close.svg";

class RequestSubscriptionBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: true
    };
  }

  hideForm = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ showForm: !this.state.showForm });
  };

  openLogin = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.openLoginTemplate();
  };

  render() {
    const publisherTitle = get(this.props, ["config", "publisher-settings", "title"], "Ahead");
    return (
      <div className="element-wrapper">
        {this.state.showForm && (
          <div styleName="metered-wrapper">
            <div onClick={event => this.hideForm(event)} styleName="close">
              <SvgHandler width="24" height="24" xlinkHref={closeIcon} />
            </div>
            <div styleName="metered-headline">Subscribe now to get unlimited access</div>
            <p styleName="metered-desc">
              We're glad you're enjoying {publisherTitle}. Login and subscribe to continue reading this story.
            </p>
            <div styleName="btn-wrapper">
              <div styleName="subscribe-btn">
                <CustomLink href={"/subscription"}>Subscribe</CustomLink>
              </div>
            </div>
            {!this.props.member && (
              <span styleName="info-text">
                Already a user? <a onClick={this.openLogin}>Login</a>
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}

RequestSubscriptionBase.propTypes = {
  member: PropTypes.object,
  openLoginTemplate: PropTypes.func
};

const mapStateToProps = state => ({
  member: get(state, ["member"], null),
  config: get(state, ["qt", "config"], {})
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" })
});

export const RequestSubscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestSubscriptionBase);
